import React from 'react';
import './Footer.css';

function Footer({ onVersionClick, showDebugToggle = false }) {
  return (
    <footer className="report-footer">
      <div className="footer-content">
        <p className="footer-text">
          © {new Date().getFullYear()} PrepScholar. All rights reserved. | <a href="https://www.prepscholar.com/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a> | <a href="https://www.prepscholar.com/terms-of-service/" target="_blank" rel="noopener noreferrer">Terms of Service</a>
        </p>
        <p 
          className={`footer-version ${showDebugToggle ? 'clickable' : ''}`}
          onClick={showDebugToggle ? onVersionClick : undefined}
          style={showDebugToggle ? { cursor: 'pointer', userSelect: 'none' } : {}}
          title={showDebugToggle ? "Click to toggle debug info" : ""}
        >
          v1.2.0
        </p>
      </div>
    </footer>
  );
}

export default Footer;

